'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports["default"] = CheckboxList;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkbox = require('./checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _isOptionSelected = require('./isOptionSelected');

var _isOptionSelected2 = _interopRequireDefault(_isOptionSelected);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function CheckboxList(_ref) {
  var values = _ref.values,
      options = _ref.options,
      onChange = _ref.onChange,
      describedBy = _ref.describedBy,
      name = _ref.name;
  return options.map(function (option, index) {
    var key = 'checkbox-' + index;
    return _react2["default"].createElement(_checkbox2["default"], _extends({}, option, {
      isSelected: (0, _isOptionSelected2["default"])(values, option),
      onChange: onChange,
      describedBy: describedBy,
      key: key,
      name: name
    }));
  });
}

CheckboxList.propTypes = {
  name: _propTypes2["default"].string,
  options: _propTypes2["default"].array.isRequired,
  values: _propTypes2["default"].array,
  onChange: _propTypes2["default"].func,
  describedBy: _propTypes2["default"].string
};
CheckboxList.defaultProps = {
  values: [],
  onChange: function onChange() {},
  describedBy: undefined,
  name: undefined
};